/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useSaleRtoAll } from './hooks/useSaleForm';
export default defineComponent({
  name: 'SaleFormProp',
  setup: function setup() {
    var route = useRoute();
    var _useSaleRtoAll = useSaleRtoAll({
        type: +route.params.type,
        startTime: route.params.startTime,
        endTime: route.params.endTime
      }),
      _useSaleRtoAll2 = _slicedToArray(_useSaleRtoAll, 2),
      saleRtoAll = _useSaleRtoAll2[0],
      getSaleRtoAllAsync = _useSaleRtoAll2[1];
    var saleData = computed(function () {
      // 使用Map按name索引价格
      var priceMap = new Map(saleRtoAll.value.stone_money_data.map(function (item) {
        return [item.name, item.value];
      }));
      return saleRtoAll.value.stone_num_data.map(function (item) {
        return {
          name: item.name,
          value: item.value,
          price: priceMap.get(item.name) || ''
        };
      });
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getSaleRtoAllAsync();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      saleData: saleData
    };
  }
});